export default __webpack_public_path__ + "static/media/institutions-shape-2.9cacb47a.svg";